import axios from 'axios'
import { useQuery } from '@tanstack/react-query'
import { extractErrorMessage } from '../utils/apitools'
import useAccount from './useAccount'
import { API_BASE_URL } from '../constants/system'
import { TrackerState } from '../types/gotypes'

// useProgrammeTracker loads the computed tracker state for a slug. The page is
// read-only — content is edited on the Programme trackers admin page — so this
// fetches and refreshes on an interval; the admin hooks also invalidate this
// query's key on every write.
export const useProgrammeTracker = (slug: string) => {
  const account = useAccount()

  const query = useQuery({
    queryKey: ['programme-tracker', slug],
    enabled: Boolean(slug && account.user),
    // Keep an open page current as Managers post updates, as the old page did.
    refetchInterval: 60_000,
    queryFn: async () => {
      try {
        const res = await axios.get<TrackerState>(`${API_BASE_URL}/projects/${slug}`)
        return res.data
      } catch (error) {
        throw new Error(extractErrorMessage(error))
      }
    },
  })

  return {
    tracker: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error instanceof Error ? query.error.message : '',
    refetch: query.refetch,
    isFetching: query.isFetching,
  }
}

export default useProgrammeTracker
